"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const uuid_1 = require("uuid");
const clsx_1 = __importDefault(require("clsx"));
const pluralize_1 = __importDefault(require("pluralize"));
const SongwriterCatalogBuilderToggle_1 = __importDefault(require("@Components/SongwriterCatalogBuilderToggle"));
const react_1 = __importDefault(require("react"));
const mobx_react_1 = require("mobx-react");
const DotsPopover_1 = __importDefault(require("@Components/DotsPopover"));
const SongwriterCatalogBuilderRow = (props) => {
    var _a;
    const { writer, onTitleClick, onWriterToggle, isChecked, requestAnUpdate } = props;
    return (react_1.default.createElement("tr", { key: (_a = writer.ipId) !== null && _a !== void 0 ? _a : (0, uuid_1.v4)() },
        react_1.default.createElement("td", null,
            react_1.default.createElement("div", { className: 'writer-data' },
                react_1.default.createElement("div", { className: 'writer-name-titles' },
                    react_1.default.createElement("span", { className: 'writer-name' },
                        writer.name,
                        ":"),
                    react_1.default.createElement("span", { className: (0, clsx_1.default)('writer-titles', !!writer.worksCount && 'clickable'), onClick: () => !!writer.worksCount && onTitleClick(writer) }, (0, pluralize_1.default)('title', writer.worksCount, true))),
                react_1.default.createElement("div", { className: 'writer-ipi' },
                    react_1.default.createElement("span", null, "IPI:"),
                    " ",
                    writer.ipiNumber))),
        react_1.default.createElement("td", null,
            react_1.default.createElement(SongwriterCatalogBuilderToggle_1.default, { onClick: (isLinked) => {
                    onWriterToggle(isLinked, Number(writer.ipId));
                }, label: isChecked ? 'In catalog' : 'Add to catalog', checked: isChecked })),
        requestAnUpdate && (react_1.default.createElement("td", null,
            react_1.default.createElement(DotsPopover_1.default, { place: 'bottom' },
                react_1.default.createElement("p", { onClick: () => requestAnUpdate({ ipId: writer.ipId, writerName: writer.name }) }, "Request an update"))))));
};
exports.default = (0, mobx_react_1.observer)(SongwriterCatalogBuilderRow);
